import Async from "components/DesignSystem/AsyncComponents/Async";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { GustoAccess } from "components/GustoAccess/GustoAccess";
import { Info } from "components/icons/Info";
import { useGetBookkeepingSettingsQuery } from "store/apis/booksLockDate";

type ConnectGustoProps = { entityId: string };

export default function ConnectGusto({ entityId }: ConnectGustoProps) {
  const {
    data: settings,
    isLoading,
    isSuccess,
  } = useGetBookkeepingSettingsQuery(
    {
      entityId,
    },
    { skip: !entityId }
  );

  return (
    <Async.Root
      isLoading={isLoading}
      isSuccess={isSuccess}
      isEmpty={settings?.gusto_access!}
      customLoader={<></>}
    >
      <Async.Empty>
        <></>
      </Async.Empty>
      <Async.Success>
        <Modal.Root>
          <Modal.Trigger asChild>
            <Button
              customType="ghost"
              size="small"
              leftIcon={<Info stroke="1.2" size="14" />}
            >
              How to connect Gusto
            </Button>
          </Modal.Trigger>
          <GustoAccess entityId={entityId} />
        </Modal.Root>
      </Async.Success>
    </Async.Root>
  );
}
